import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { reauthorizationWhaleSpace } from '../../extApis/whaleSpaceApi';

const ContensBody = styled.div`
  width: 100%;
  height: 100%;
`;

export default function WhaleAuth() {
  const { t } = useTranslation();

  useEffect(() => {
    reauthorizationWhaleSpace(true);
  }, []);

  return <ContensBody />;
}
